import React, { Component } from 'react';
import { Guardian } from '@xaamin/guardian';
import { Dropdown, ButtonGroup } from 'react-bootstrap';

import { Http } from '../../../../../support';
import LoadingButton from '../../../../../facturotopia/LoadingButton';
import AutofacturacionFileStatus from '../../../enum/AutofacturacionFileStatus';

class AutofacturacionItemActions extends Component {
  state = {
    busy: false,
    showConfirm: false,
  };

  handleOnCancelActionClick = () => {
    this.setState({
      showConfirm: true,
    });
  };

  handleOnDownloadActionClick = async (original) => {
    const { selectedRowKeys } = this.props;

    this.setState({
      busy: true,
    });

    try {
      const params = {
        as: 'link',
        original: original,
      };
      const response = await Http.get(`${window.BONJOUR_URL}/api/autofacturacion/${selectedRowKeys[0]}`, { params });

      window.location = response.data.link;
    } catch (error) {
    } finally {
      this.setState({
        busy: false,
      });
    }
  };

  handleOnRetryIndividualStamping = async (status) => {
    this.setState({
      busy: true,
    });

    try {
      const response = await Http.post('api/autofacturacion/files/retry', {
        status,
        ids: this.getFileKeys(),
      });

      this.setState({
        busy: false,
      });

      window.ToastManager.show({
        variant: 'success',
        title: 'Success',
        message:
          response.data?.message ?? response.message ?? 'Se han reservado los recursos para procesar tu solicitud.',
      });
    } catch (error) {
      this.setState({
        busy: false,
        error: error.data || error,
      });

      window.ToastManager.show({
        variant: 'error',
        title: 'Error',
        message:
          error.data?.message ?? error.message ?? 'Ha ocurrido un error procesando tu solicitud, intenta más tarde.',
      });
    }
  };

  getFileKeys = () => {
    const { selectedRows } = this.props;

    return selectedRows
      .filter((item) => item.status === AutofacturacionFileStatus.uploaded().getValue())
      .map((item) => item.id);
  };

  handleOnAction = (action) => {};

  render() {
    const { alignRight, selectedRowKeys } = this.props;
    const { busy } = this.state;

    const fileKeys = this.getFileKeys();

    return (
      <Dropdown
        variant="secondary"
        as={ButtonGroup}
        alignRight={alignRight}
      >
        <LoadingButton
          variant="secondary"
          loading={busy}
          onClick={() => {}}
        >
          {busy === true ? 'Procesando' : 'Acciones'}
        </LoadingButton>

        <Dropdown.Toggle
          split
          variant="secondary"
          id="dropdown-split-basic"
        />

        <Dropdown.Menu>
          {selectedRowKeys.length === 1 && Guardian.allows('autofacturacion.descargar.excel.procesado') && (
            <Dropdown.Item
              as="div"
              onClick={this.handleOnDownloadActionClick.bind(this, undefined)}
            >
              Descargar procesado
            </Dropdown.Item>
          )}

          {Guardian.allows('autofacturacion.descargar.archivo.original') && (
            <Dropdown.Item
              as="div"
              onClick={this.handleOnDownloadActionClick.bind(this, 1)}
            >
              Descargar original
            </Dropdown.Item>
          )}

          {fileKeys.length > 0 && (
            <Dropdown.Item
              as="div"
              onClick={this.handleOnRetryIndividualStamping.bind(this, 8)}
            >
              Reenviar a timbrado
            </Dropdown.Item>
          )}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

export default AutofacturacionItemActions;
